import React, { useEffect, useState } from 'react';
import { Checkbox, Menu, Modal } from 'antd';
import { json, useNavigate } from 'react-router-dom';
import Login from '../Pages/Auth/Login';
import {
    AuditOutlined,
    BankOutlined,
    CalculatorFilled,
    CopyFilled,
    DashboardFilled,
    FileDoneOutlined,
    PoweroffOutlined,
    PercentageOutlined,
    SettingOutlined,
    ToolFilled,
    UserOutlined,
    UsergroupAddOutlined,
    ApartmentOutlined,
    DatabaseOutlined,
    InfoCircleOutlined,
    FileOutlined,
    CalculatorOutlined
} from '@ant-design/icons';
import { UtilisateurService } from '../Services/UtilisateurService';

const rootSubmenuKeys = ['dashboard', 'structure', 'params', 'docs', 'extradocs', 'process', 'compta', 'extra', 'paie', 'text&reglement', 'signout'];

const items = [
    {
        label: 'Tableau de Bord',
        key: 'dashboard',
        icon: <DashboardFilled />
    },
    {
        label: 'Fichiers ',
        key: 'structure',
        icon: <ApartmentOutlined />,
        children: [
            { label: 'Données de Base', key: '/donnees_bases', icon: <FileDoneOutlined />, disabled: false },
            { label: 'Adhérents', key: '/adherents', icon: <BankOutlined />, disabled: false },
            { label: 'Fournisseurs de Soins', key: '/fournisseurs', icon: <AuditOutlined />, disabled: false },
            { label: 'Participants', key: '/participants', icon: <UsergroupAddOutlined />, disabled: false }
        ]
    },
    {
        label: 'Paramètres',
        key: 'params',
        icon: <SettingOutlined />,
        children: [
            { label: 'Taux de Prise en Charge', key: '/tauxpc', icon: <PercentageOutlined />, disabled: false },
            { label: 'Utilisateurs', key: '/users', icon: <UserOutlined />, disabled: false },
            { label: "Informations Générales", key: "/informations", icon: <InfoCircleOutlined />, disabled: false },

        ]
    },
    {
        label: 'Documents',
        key: 'docs',
        icon: <CopyFilled />,
        children: [
            { label: 'Bons de Pharmacies', icon: '', key: '/bons_pharmacies', disabled: false },
            { label: 'Lettres de Garantie', icon: '', key: '/lettres_garanties', disabled: false },
            { label: 'Bons Optiques', icon: '', key: '/bons_optiques', disabled: false },
            { label: 'Lettres Hospitalisation', icon: '', key: '/lg_hospitalisation', disabled: false },
            /* { label: 'Tickets Remboursement', icon: '', key: '/ticket_remboursement' }, */
            /*  { label: 'Factures Société', icon: '', key: '/factures_societes' },
             { label: "Ordres de Paiement", icon: "", key: "/ordre_paiement" },
             { label: "Bons d'Achat", icon: "", key: "/bon_achat" } */
        ]
    },
    {
        label: 'Extra - Documents',
        key: 'extradocs',
        icon: <CopyFilled />,
        children: [

            { label: "Ordres de Paiement", icon: "", key: "/ordre_paiement", disabled: false },
            { label: "Bons d'Achat", icon: "", key: "/bon_achat", disabled: false },
            { label: "Factures Adhérents", icon: "", key: "/Facture_Adherent", disabled: false }
        ]
    },
    {
        label: 'Traitements - Saisies',
        key: 'process',
        icon: <ToolFilled />,
        children: [
            { label: 'Factures Fournisseurs', icon: '', key: '/factures', disabled: false },
            { label: 'Réglement Factures', icon: '', key: '/reglements', disabled: false },
            { label: 'Saisie Encaissement ', icon: '', key: '/saisie_encaissement', disabled: false },
            { label: 'Saisie Cotisations', icon: '', key: '/cotisations', disabled: false },
            { label: 'Saisie Journal', icon: '', key: '/saisie_journal', disabled: false },
            { label: 'Retenues Frais Médicaux', icon: '', key: '/retenues', disabled: false },
            { label: 'Remb. Frais Médicaux', icon: '', key: '/remboursements' },
            { label: 'Suspensions', icon: '', key: '/suspensions' },

        ]
    },

    {
        label: 'Comptabilité',
        key: 'compta',
        icon: <CalculatorFilled />,
        children: [
            { label: 'Journal Central', icon: '', key: '/journal-central', disabled: false },
            { label: 'Plan Comptable', icon: '', key: '/plancompta', disabled: false },
            { label: 'Interrogations Comptes', icon: '', key: '/interrogation_compte', disabled: false },
            { label: 'Etat Compta & Fin', icon: '', key: '/etat_comptafin', disabled: false }
        ]
    },
    {
        label: 'Extra - Compta',
        key: 'extra',
        icon: <CalculatorOutlined />,
        children: [
            { label: 'Rapp. Bancaires', icon: '', key: '/rapport_banque', disabled: false },
            { label: 'Immobilisations', icon: '', key: '/immobilisation', disabled: false },
            { label: 'Prévision Budget', icon: '', key: '/budget', disabled: false },
            { label: 'Reporting & Export', icon: '', key: '/reporting', disabled: false }
        ]
    },
    {
        label: 'Paie et RH',
        key: 'paie',
        icon: <DatabaseOutlined />,
        children: [
            { label: 'Gestion Paie', icon: '', key: '/gestion-paie', disabled: false },
        ]
    },
    {
        label: "Textes et Réglements",
        icon: <FileOutlined />,
        key: 'text&reglement',
        disabled: false
    },
    {
        label: "Déconnexion",
        icon: <PoweroffOutlined />,
        key: "signout"
    }
];

export default function SideMenu() {
    const navigate = useNavigate();
    const userProfil = localStorage.getItem("profil");
    const roleName = localStorage.getItem("role_name");
    const [openKeys, setOpenKeys] = useState([roleName === 'Point Focal' ? 'docs' : 'dashboard']);
    const [selectedKeys, setSelectedKeys] = useState([window.location.pathname]);
    const gestionUsersService = new UtilisateurService();

    const [privileges, setPrivileges] = useState([]);

    // const userConnect = JSON.parse(localStorage.getItem("user_connect"));

    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };
    
    // Écouter l'événement personnalisé pour sélectionner un item du menu
    useEffect(() => {
        const handleSelectMenuItem = (event) => {
            const { key } = event.detail;
            setSelectedKeys([key]);
            setOpenKeys([]); // Fermer tous les sous-menus
        };
        
        window.addEventListener('selectMenuItem', handleSelectMenuItem);
        
        return () => {
            window.removeEventListener('selectMenuItem', handleSelectMenuItem);
        };
    }, []);


    useEffect(() => {
        const fetchPrivileges = async () => {
            if (userProfil) {
                try {
                    const privileges = await gestionUsersService.getUserPrivileges(userProfil);
                    setPrivileges(privileges);
                    console.log('Privilèges récupérés :', privileges);

                } catch (error) {
                    console.error('Erreur lors de la récupération des privilèges :', error);
                }
            }
        };

        fetchPrivileges();
    }, []);

    // Ajoute cette fonction utilitaire dans SideMenu.js

    function applyPrivilegesToMenuItems(items, privileges) {
        // Crée une map pour un accès rapide aux privilèges par alias
        const privilegeMap = {};
        privileges.forEach(priv => {
            privilegeMap[priv.alias] = priv.valeur;
        });

        // Parcours récursif des items pour appliquer la propriété disabled
        return items.map(item => {
            if (item.children && Array.isArray(item.children)) {
                return {
                    ...item,
                    children: item.children.map(child => ({
                        ...child,
                        disabled: privilegeMap.hasOwnProperty(child.key)
                            ? !privilegeMap[child.key] // disabled = true si valeur = false
                            : child.disabled // garde la valeur existante si pas de correspondance
                    }))
                };
            }
            return item;
        });
    }

    const menuItemsWithPrivileges = applyPrivilegesToMenuItems(items, privileges);

    // Filtrer les menus racines si le role est "Point Focal" pour ne laisser que "docs" et "signout"
    const filteredMenuItems = roleName === 'Point Focal'
        ? menuItemsWithPrivileges.filter(mi => mi.key === 'docs' || mi.key === 'signout')
        : menuItemsWithPrivileges;


    return (
        <div>
            <Menu
                onClick={({ key }) => {
                    if (key === "signout") {
                        Modal.confirm({
                            title: "Déconnexion",
                            content: "Voulez-vous vraiment quitter l'application?",
                            okText: "Oui",
                            okType: 'danger',
                            cancelText: 'Annuler',
                            centered: true,
                            onOk: () => {
                                localStorage.removeItem("auth");
                                localStorage.removeItem("user_connect");
                                localStorage.removeItem("login");
                                localStorage.removeItem("password");
                                localStorage.removeItem("username");
                                localStorage.removeItem("profil");
                                localStorage.removeItem("role_name");
                                localStorage.removeItem("emailaddress");
                                localStorage.removeItem("perim");
                                navigate("/login");
                                window.location.reload(true);
                                return (<Login />);
                            }
                        });
                    } else {
                        setSelectedKeys([key]);
                        navigate(key);
                    }
                }}
                selectedKeys={selectedKeys}
                mode="inline"
                items={filteredMenuItems}
                theme='dark'
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                style={{ fontWeight: 'bold', textDecorationColor: "#fff", color: "#fff" }}
            />
        </div>
    );
}
